import { render } from "./publicLayout.vue?vue&type=template&id=5df3ac3c&scoped=true"
const script = {}

import "./publicLayout.vue?vue&type=style&index=0&id=5df3ac3c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df3ac3c"]])

export default __exports__